import _ from "lodash-es";
import { AxiosResponse } from "axios";

export default abstract class Model {
  protected _resp?: AxiosResponse;
  protected _isAssigned = false;
  public _isAssignedFlag = false; //判断是否合并过接口数据 对外用
  private _defaultValue: any; //用于对比是否改过值

  constructor(resp?: AxiosResponse) {
    this._resp = resp;
  }

  get isAssigned(): boolean {
    return this._isAssigned;
  }

  public delete_defaultValue() {
    delete this._defaultValue;
  }

  public assign(data: object) {
    const keys = _.keys(this);
    for (const key of keys) {
      let value = _.get(this, key);
      value = this.getValue(value, _.get(data, key), key);
      _.set(this, key, value);
    }
    if (data) {
      this._isAssigned = true;
      this._isAssignedFlag = true;
    }
    return this;
  }

  clearArray() {
    const keys = _.keys(this);
    for (const key of keys) {
      const value = _.get(this, key);
      if (value instanceof Array) {
        _.set(this, key, []);
      } else if (value instanceof Model) {
        value.clearArray();
      }
    }
    return this;
  }

  public objectArrayClasses(): object {
    return {};
  }

  protected getValue(
    value: object | boolean | string | number, //前端定义值
    data: object | boolean | string | number, //接口值
    key: string
  ): object | boolean | string | number {
    if (_.isUndefined(data)) {
      return value;
    }
    switch (typeof value) {
      case "boolean":
        if (data === "1" || data === 1 || data === true) {
          value = true;
        } else if (data === "0" || data === 0 || data === false) {
          value = false;
        } else {
          value = Boolean(data).valueOf();
        }
        break;
      case "number":
        value = !isNaN(parseFloat(data as string))
          ? parseFloat(data as string)
          : value; //todo
        break;
      case "string":
        value = data ? String(data).valueOf() : "";
        break;
      case "object":
        if (value instanceof Model) {
          value.assign(data as object);
        } else if (value instanceof Array) {
          if (_.has(this.objectArrayClasses(), key)) {
            if (data instanceof Array) {
              value.splice(0, value.length);
              for (const i in data) {
                const cls = _.get(this.objectArrayClasses(), key);
                if (["boolean", "number", "string"].includes(typeof cls)) {
                  value.push(data[i]);
                } else {
                  const obj = new cls() as Model;
                  obj.assign(data[i] as object);
                  value.push(obj);
                }
              }
            }
          } else {
            const first = value.pop();
            if (first !== undefined && data instanceof Array) {
              _.forEach(data, (v, i) => {
                if (first instanceof Model) {
                  _.set(value as object, i, _.cloneDeep(first).assign(v));
                } else if (first instanceof Array) {
                  _.set(
                    value as object,
                    i,
                    this.getValue(_.cloneDeep(first), v, key)
                  );
                } else {
                  _.set(value as object, i, this.getValue(first, v, key));
                }
              });
            }
          }
        } else {
          value = data;
        }
        break;
    }
    return value;
  }

  //设置对比用的默认值
  public setDefaultValue(): void {
    this._defaultValue = _.cloneDeep(this);
  }

  //当前值对比默认值 是否改变
  public compareWithDefaultValue(extraChangeFunc: Function): boolean {
    const currentValue = _.cloneDeep(this);
    //如果需要额外处理某些字段，可以传入一个函数
    if (extraChangeFunc) {
      extraChangeFunc(currentValue);
    }
    return this.isObjectValueEqual(this._defaultValue, currentValue);
  }

  public isObjectValueEqual(a: any, b: any): boolean {
    //判断两个对象是否相等。如果是基本类型，直接用“===“，如果是引用类型，递归判断
    //首先判断a和b的数据类型
    if (typeof a !== typeof b) {
      return false;
    }
    //如果是基本类型，直接比较
    if (
      typeof a === "number" ||
      typeof a === "string" ||
      typeof a === "boolean"
    ) {
      return a === b;
    }
    //如果是对象类型，先判断是否为null，再判断属性个数是否相等，最后递归判断属性值是否相等
    if (a === null || b === null) {
      //如果是null
      return a === b;
    }
    if (a === undefined || b === undefined) {
      //如果是undefined
      return a === b;
    }
    if (a instanceof Array || b instanceof Array) {
      //如果是数组
      if (a.length !== b.length) {
        return false;
      }
      for (let i = 0; i < a.length; i++) {
        if (!this.isObjectValueEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    if (a instanceof Object || b instanceof Object) {
      //如果是对象

      //取对象a和b的属性名
      const aProps = Object.getOwnPropertyNames(a);
      const bProps = Object.getOwnPropertyNames(b);
      //判断属性名的length是否一致
      if (aProps.length != bProps.length) {
        return false;
      }
      //循环取出属性名，再判断属性值是否一致
      for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i];
        if (!this.isObjectValueEqual(a[propName], b[propName])) {
          // console.log("===================");
          // console.log(propName);
          // console.log(a[propName]);
          // console.log(b[propName]);
          return false;
        }
      }
      return true;
    }
    return false;
  }
}
